<template>
  <div>
    <div class="fix-wrapper">
      <breadcrumb
        :crumbs="[$t('menu.products'), $t('action.importIngredient')]"
      ></breadcrumb>
      <div class="container">
        <div class="pd20">
          <div class="import">
            <ul class="orange">
              <li class="explain">
                {{ $t("newImportIngredient.excelTitle") }}
              </li>
              <li class="explain">
                {{ $t("newImport.excelTemplate") }}:
                <a :href="excelTemplate" target="_blank">{{
                  $t("newImport.clickDownload")
                }}</a>
              </li>
              <li class="explain">
                {{ $t("newImport.beCareful") }}：1、{{
                  $t("newImport.beCarefulMustFill")
                }}
              </li>
              <li class="beCareful">
                2、{{ $t("newImportIngredient.beCarefulProductNo") }}
              </li>
              <li class="beCareful">
                3、{{ $t("newImportIngredient.beCarefulMaterialSerialNo") }}
              </li>
            </ul>
          </div>
          <div class="center">
            <el-upload
              ref="upload"
              :action="url"
              :headers="fileHeaders"
              :show-file-list="false"
              :before-upload="beforeAvatarUpload"
              :on-success="importResult"
              accept=".xls, .xlsx"
            >
              <el-button
                type="success"
                size="small"
                style="width: 100px"
                :loading="importLoading"
                >{{ $t("action.import") }}</el-button
              >
            </el-upload>
          </div>
          <div v-if="results.length != 0">
            <span class="mgl15">{{ $t("newImport.results") }}：</span>
            <ol class="import">
              <li v-for="(r, index) of results" :key="index" class="explain">
                <span v-if="r.type == 'fail'" class="grey">{{
                  r.message
                }}</span>
                <span v-if="r.type == 'success'" class="green">{{
                  r.message
                }}</span>
              </li>
            </ol>
          </div>
        </div>

        <div class="form-footer">
          <back-button />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { page } from "@/utils/mixins.js";
import BackButton from "@/components/BackButton";
import { coreMmsEndpoint, fileserverEndpoint } from "@/settings";
import Cookies from "@/utils/cookies.js";

export default {
  mixins: [page],
  components: { BackButton },
  data() {
    return {
      excelTemplate:
        fileserverEndpoint +
        "/public/excelTemplates/jy_importProductMaterials.xlsx",
      // 导入

      url: coreMmsEndpoint + "/excels/import-product-materials",
      fileHeaders: {
        type: "web",
        token: Cookies.getToken(),
      },
      results: [],
      importLoading: false,
    };
  },

  computed: {},
  created() {
    this.results = [];
  },
  methods: {
    // 导入
    beforeAvatarUpload(file) {
      this.importLoading = true;
      return true;
    },
    importResult(res, file) {
      const self = this;
      this.importLoading = false;
      self.results = res.results;
      if (res.allQuantity === res.successQuantity) {
        const text = "成功导入" + res.successQuantity + "条记录";
        self.$message({ message: text, type: "success" });
      } else {
        self.$message({ message: "查看详细", type: "warning" });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>